export default __webpack_public_path__ + "static/media/194.495f0e8a.gif";